module.exports = __webpack_public_path__ + "img/closemodal.d0587873.svg";